import { render } from "./AsyncHandlingOverview.vue?vue&type=template&id=2fabfeab&scoped=true&ts=true"
import script from "./AsyncHandlingOverview.vue?vue&type=script&lang=ts"
export * from "./AsyncHandlingOverview.vue?vue&type=script&lang=ts"

import "./AsyncHandlingOverview.vue?vue&type=style&index=0&id=2fabfeab&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fabfeab"]])

export default __exports__